import { useEffect, useState } from "react";

/**
 * The channel picked on 对话 or on 客户表, one choice for both pages: they
 * count the same work lists, and a button saying 55 over both networks beside
 * a step saying 53 over one read as two systems keeping their own books
 * (owner, 2026-09-23: 「各个板块各做各的」). "" is 全部, on both pages.
 * Kept for the visit, not across reloads: the inbox opens on 全部 every time,
 * so a Messenger chat is never hidden by yesterday's choice.
 */
let current = "";
const listeners = new Set<(n: string) => void>();

export function setNetChoice(n: string) {
  if (n === current) return;
  current = n;
  for (const l of listeners) l(n);
}

/** The shared choice, and a setter that moves both pages. */
export function useNetChoice(): [string, (n: string) => void] {
  const [n, setN] = useState(current);
  useEffect(() => {
    listeners.add(setN);
    setN(current);
    return () => {
      listeners.delete(setN);
    };
  }, []);
  return [n, setNetChoice];
}
